import { Fragment } from 'react';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { handleChangeDate } from '../../../../helpers/handleChange';
import { useSidebar } from '../../../../helpers/sidebarClose';
import { ACCOUNT_RPT_DATE } from '../../../../store/orgSlice';
import { useDispatch } from 'react-redux';

interface TranRptFormProps {
  setOnDayBookReport: any;
}
const DayBookFormView: React.FC<TranRptFormProps> = ({ setOnDayBookReport }) => {
  const { closeSidebar } = useSidebar('day_book_rpt');
  const dispatch = useDispatch();
  const initialValues = {
    date_n: "",
  };
  const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
        const formData = new FormData();
        formData.append("date_n", values.date_n || "");
        await postDataToTheServer(AppURL.AccountURL + `account/day/book/report/list/view/`, formData).then((res) => {
          setOnDayBookReport(res);
          closeSidebar();
          dispatch(ACCOUNT_RPT_DATE({
            date: "",
            date_from: values.date_n || "",  // Provide empty string if undefined
            date_to: values.date_n || "",  // Provide empty string if undefined
          }));
        });
    },
  });
 
  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <Grid container columnSpacing={3} rowSpacing={1}>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <InputTextBox
              type='text'
              name='date_n'
              label='Date(B.S.)'
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_n' })}
              value={values.date_n}
              error={errors.date_n}
              handleBlur={handleBlur}
              touched={touched.date_n}
              required={true}
              placeholder='XXXX/XX/XX'
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <EndBaseLine top={18}>
              <Button btn_type='search' loading={isSubmitting} type='submit' el='button' />
            </EndBaseLine>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  )
}

export default DayBookFormView
